// @flow
import React from 'react';
import { Label } from 'reactstrap';
import i18n from './../i18n/i18n'


/**
 * Překladová komponenta
 */
class TranslateComponent extends React.Component {

    static PropTypes = {
        message: React.PropTypes.string.isRequired
    };

    static defaultProps = {
        component: Label,
    };

    static contextTypes = {
        fieldLabelPrefix: React.PropTypes.oneOfType([React.PropTypes.string, React.PropTypes.array]),
        formPath: React.PropTypes.string,
    };

    render() {
        const {component, message, ...otherProps} = this.props;
        const {fieldLabelPrefix, formPath} = this.context;

        let text;
        if (!message) {
            throw new Error('Message for translate not specified!!');
        }
        if (fieldLabelPrefix) {
            if (Array.isArray(fieldLabelPrefix)) {
                const keys = fieldLabelPrefix.map(key => formPath ? key + message.substring(formPath.length) : key + message);
                text = i18n(keys);
            } else {
                if (formPath) {
                    text = i18n(fieldLabelPrefix + message.substring(formPath.length));
                } else {
                    text = i18n(fieldLabelPrefix + message);
                }
            }
        } else if (typeof message === "string") {
            text = i18n('^' + message);
            if (text === null) {
                text = message;
            }
        }

        return React.createElement(component, otherProps, text);
    }
}

export default TranslateComponent
